import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetCommunityApprovalInfoProps {
  community_id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunityApprovalInfo = async (ID: string) =>
  await axiosAuth.get(`${GET_COMMUNITIES}/${ID}/approval-settings`);

const useGetCommunityApprovalInfo = ({
  community_id,
  queryParams,
}: UseGetCommunityApprovalInfoProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community-approval-info", community_id],
    queryFn: () => getCommunityApprovalInfo(community_id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetCommunityApprovalInfo;
